import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from '../axios';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import HeaderSecond from '../HeaderSecond';
import LoaderImg from '../img/logo/running.gif';
import Footer from '../Footer';

const SitemapXml = () => {
  // console.log("Create Event page");
  const navigate = useNavigate();
  const [EventDetails, setEventDetails] = useState([]);
  const [SitemapDetails, setSitemapDetails] = useState([]);
  const [Loader, setLoader] = useState(false);
  const mainUrlLink = window.location.origin;

  const handleBackToHome = () => {
    localStorage.removeItem('EventViewFlag');
    localStorage.removeItem('EventDetailsId');

    const CountryCode = localStorage.getItem('CountryCode');
    const CountryName = localStorage.getItem('Country');
    navigate('/' + CountryCode + '/' + CountryName);
  }

  useEffect(() => {
    const UrlLink = window.location.origin;
    window.scrollTo(0, 0);
    setLoader(true);
    axios.post("get_seo_category_events",{'url_link': UrlLink})
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          setEventDetails(response.data.data.category_data);
          setSitemapDetails(response.data.data.final_sitemap_data);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      })
  }, [])
  // console.log(EventDetails);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  

const generateSitemapXML = (SitemapDetails) => {
  const mainUrlLink = window.location.origin

  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`
  xml += `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n`

  if (SitemapDetails && Array.isArray(SitemapDetails)) {
    SitemapDetails.forEach((link) => {
      xml += `  <url>\n`
      xml += `    <loc>${link}</loc>\n`
      xml += `    <changefreq>monthly</changefreq>\n`
      xml += `    <priority>0.8</priority>\n`
      xml += `  </url>\n`
    })
  }

  xml += `</urlset>`
  return xml
}

//---------------------
  return (
    <>
   
      <pre >
        {generateSitemapXML(SitemapDetails)}
      </pre>
                
    </>
  )
}

export default SitemapXml;

